module.exports = __webpack_public_path__ + "img/nfi_slide_1.daba750e.jpg";